"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SplitWithImage = SplitWithImage;
const react_1 = __importDefault(require("react"));
const styles_1 = require("@material-ui/styles");
const clsx_1 = __importDefault(require("clsx"));
const core_1 = require("@material-ui/core");
const __1 = require("../..");
const useStyles = (0, styles_1.makeStyles)({
    wrapper: {
        paddingTop: __1.StyleVariables.spacing(3),
        paddingBottom: __1.StyleVariables.spacing(3),
    },
    image: {
        width: '100%',
        height: '100%',
    },
});
function SplitWithImage({ leftGridSize, rightGridSize, children, className, imageUrl, imageAltText, spacing, mdDownHide, }) {
    const classes = useStyles();
    return (react_1.default.createElement(Split, { leftGridSize: leftGridSize, rightGridSize: rightGridSize, spacing: spacing, className: className, mdDownHide: mdDownHide },
        children,
        react_1.default.createElement("img", { src: imageUrl, alt: imageAltText, className: classes.image })));
}
function Split({ leftGridSize, rightGridSize, children, className, spacing, mdDownHide, ...rest }) {
    const [leftChild, rightChild] = children;
    const classes = useStyles();
    const renderRightChild = (rightChild, mdDownHide = false) => {
        if (mdDownHide)
            return (react_1.default.createElement(core_1.Hidden, { mdDown: true },
                react_1.default.createElement(core_1.Grid, { item: true, sm: rightGridSize }, rightChild)));
        return (react_1.default.createElement(core_1.Grid, { item: true, sm: rightGridSize }, rightChild));
    };
    return (react_1.default.createElement("div", { className: (0, clsx_1.default)(className, classes.wrapper), ...rest },
        react_1.default.createElement(core_1.Grid, { container: true, spacing: spacing, justifyContent: "center", alignItems: "stretch" },
            react_1.default.createElement(core_1.Grid, { item: true, sm: 1 }, ' '),
            react_1.default.createElement(core_1.Grid, { item: true, sm: leftGridSize }, leftChild),
            react_1.default.createElement(core_1.Grid, { item: true, sm: 1 }, ' '),
            renderRightChild(rightChild, mdDownHide),
            react_1.default.createElement(core_1.Grid, { item: true, sm: 1 }, ' '))));
}
